import { render, staticRenderFns } from "./AwardsAndCertifications.vue?vue&type=template&id=e16c47fa&"
import script from "./AwardsAndCertifications.vue?vue&type=script&lang=js&"
export * from "./AwardsAndCertifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports